import React from 'react';

import { Helmet } from 'react-helmet';

import { Box } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import BundleList from './components/BundleList';

function BundlesListPage() {
  return (
    <Box>
      <Helmet>
        <title>Bundles</title>
      </Helmet>

      <PageHeader title="Bundles" />

      <Box mt={1}>
        <BundleList />
      </Box>
    </Box>
  );
}

export default BundlesListPage;
